"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChainRegistryClient = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _chainUtil = require("./chain-util");
var _fetcher = require("./fetcher");
var _excluded = ["chainNames", "assetListNames", "ibcNamePairs", "baseUrl"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var ChainRegistryClient = /*#__PURE__*/function (_ChainRegistryFetcher) {
  (0, _inherits2["default"])(ChainRegistryClient, _ChainRegistryFetcher);
  var _super = _createSuper(ChainRegistryClient);
  function ChainRegistryClient(options) {
    var _this;
    (0, _classCallCheck2["default"])(this, ChainRegistryClient);
    var chainNames = options.chainNames,
      assetListNames = options.assetListNames,
      ibcNamePairs = options.ibcNamePairs,
      baseUrl = options.baseUrl,
      restOptions = (0, _objectWithoutProperties2["default"])(options, _excluded);
    _this = _super.call(this, restOptions);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_options", {
      chainNames: [],
      baseUrl: 'https://raw.githubusercontent.com/cosmos/chain-registry/master'
    });
    _this._options = _objectSpread(_objectSpread({}, _this._options), {}, {
      chainNames: chainNames || _this._options.chainNames,
      assetListNames: assetListNames || _this._options.assetListNames,
      ibcNamePairs: ibcNamePairs || _this._options.ibcNamePairs,
      baseUrl: baseUrl || _this._options.baseUrl
    });
    _this.generateUrls();
    return _this;
  }
  (0, _createClass2["default"])(ChainRegistryClient, [{
    key: "generateUrls",
    value: function generateUrls() {
      var _this$_options = this._options,
        chainNames = _this$_options.chainNames,
        assetListNames = _this$_options.assetListNames,
        ibcNamePairs = _this$_options.ibcNamePairs,
        baseUrl = _this$_options.baseUrl;
      var chainUrls = chainNames.map(function (chain) {
        return "".concat(baseUrl, "/").concat(chain, "/chain.json");
      });
      var assetlistUrls = (assetListNames || chainNames).map(function (chain) {
        return "".concat(baseUrl, "/").concat(chain, "/assetlist.json");
      });
      var namePairs = ibcNamePairs;
      if (!namePairs) {
        namePairs = [];
        for (var i = 0; i < chainNames.length; i++) {
          for (var j = i + 1; j < chainNames.length; j++) {
            namePairs.push([chainNames[i], chainNames[j]]);
          }
        }
      }
      var ibcUrls = namePairs.map(function (namePair) {
        var fileName = namePair[0].localeCompare(namePair[1]) <= 0 ? "".concat(namePair[0], "-").concat(namePair[1], ".json") : "".concat(namePair[1], "-").concat(namePair[0], ".json");
        return "".concat(baseUrl, "/_IBC/").concat(fileName);
      });
      this.urls = (0, _toConsumableArray2["default"])(new Set([].concat((0, _toConsumableArray2["default"])(chainUrls), (0, _toConsumableArray2["default"])(assetlistUrls), (0, _toConsumableArray2["default"])(ibcUrls), (0, _toConsumableArray2["default"])(this.urls || []))));
    }
  }, {
    key: "getChainUtil",
    value: function getChainUtil(chainName) {
      var chainInfo = this.getChainInfo(chainName);
      return new _chainUtil.ChainRegistryChainUtil({
        chainName: chainName,
        chainInfo: chainInfo
      });
    }
  }]);
  return ChainRegistryClient;
}(_fetcher.ChainRegistryFetcher);
exports.ChainRegistryClient = ChainRegistryClient;